import Component from '@glimmer/component';
import type { ToggleButtonVariant } from '..';

export interface ToggleButtonItemSignature {
  Args: {
    count?: number;
    isActive: boolean;
    iconName?: string;
    onClick: () => void;
    variant?: ToggleButtonVariant;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLButtonElement;
}

export default class ToggleButtonComponent extends Component<ToggleButtonItemSignature> {
  get variant() {
    return this.args.variant ?? 'default';
  }
}
